export enum GameId {
  Solitaire = 'solitaire',
  Blocks = 'blocks',
  Blackjack = 'blackjack',
  TwentyOne = 'twentyone',
  Slots = 'slots',
}
